/* eslint-disable react/require-default-props */
import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { hasCookie, setCookie } from 'services/actions/cookies_actions';
import { Container } from './styles';

interface BannerBondProps {
  show?: boolean;
  onClose?: () => void;
}

const BannerBondModal = ({ show, onClose }: BannerBondProps) => {
  const [internalShow, setInternalShow] = useState(false);

  useEffect(() => {
    if (!hasCookie('BondModal')) {
      setInternalShow(true);
    }
  }, []);

  const handleClose = () => {
    setCookie('BondModal', true);
    setInternalShow(false);
    if (onClose) onClose();
  };

  const shouldShow = internalShow || show;

  return (
    <Modal size="lg" show={shouldShow} onHide={handleClose}>
      <Container>
        <div className="modal-body modal-bond">
          <button aria-label="Close" className="close" onClick={handleClose} type="button">
            <span aria-hidden="true">×</span>
          </button>
          <div className="row">
            <div className="col-12 col-md-6 px-4 py-2 mt-5">
              <span className="badge badge-new text-uppercase">
                novidade no gerenciar licitações
              </span>
              <h3 className="mb-0">Não perca nenhuma</h3>
              <h3 className="mb-3 text-green">atualização importante</h3>
              <p>
                Fique por dentro das atualizações essenciais sobre as suas{' '}
                <strong>Licitações Gerenciadas</strong>.
              </p>
              <p>
                Agora você vai receber alertas sobre <strong>impugnações, esclarecimentos</strong> e{' '}
                <strong>outros avisos</strong> diretamente no seu WhatsApp ou por e-mail.
              </p>
            </div>
          </div>
        </div>
      </Container>
    </Modal>
  );
};

export default BannerBondModal;
